import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { scheduleScrollToHomeSection } from '../lib/homeSectionNavigation';

/**
 * Footer / in-app link to a homepage section.
 * Same-page: update hash and jump instantly (no smooth scroll).
 * Other routes: navigate to /#section; HomePage hash effect completes the jump.
 */
export default function HomeSectionLink({ sectionId, children, className, onClick }) {
  const location = useLocation();
  const hashPath = `/#${sectionId}`;

  const handleClick = (event) => {
    onClick?.(event);
    if (event.defaultPrevented) return;

    if (location.pathname === '/') {
      event.preventDefault();
      if (window.location.hash !== `#${sectionId}`) {
        window.history.replaceState(null, '', hashPath);
      }
      scheduleScrollToHomeSection(sectionId, { behavior: 'auto' });
    }
  };

  return (
    <Link to={hashPath} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
}
